export default __webpack_public_path__ + "static/media/GelBoxBufferOpen.d56f7eef.svg";